const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/_user/events/drafts/new.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
export const Route = createFileRoute("/_authenticated/_feature_announcement/_user/events/drafts/new")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(z.object({
    postTo: z.string().uuid().optional()
  })),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Create Event Draft",
      description: "Page title for the create event draft path"
    })
  }
});